module.exports = __webpack_public_path__ + "img/icon_alim_fillin.c87de132.svg";